import React from 'react';
import { motion } from 'framer-motion';
import { WhatsAppButton } from './WhatsAppButton';
export const CTABanner: React.FC = () => {
  return <section className="py-20 bg-primary border-y-3 border-text relative overflow-hidden" data-id="element-28">
      {/* Decorative Elements */}
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -top-20 -left-20 w-64 h-64 bg-white border-3 border-text blob-3 opacity-30" data-id="element-29" />
      <motion.div animate={{
      rotate: -360
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -bottom-20 -right-20 w-80 h-80 bg-accent border-3 border-text blob-2 opacity-30" data-id="element-30" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto" data-id="element-32">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black mb-8 leading-tight" data-id="element-33">
            ¿Listo para darle a tu mascota el{' '}
            <span className="bg-white px-4 py-1 border-3 border-text rounded-2xl inline-block transform -rotate-2 neo-shadow-sm" data-id="element-34">
              mejor cuidado?
            </span>
          </h2>
          <p className="text-2xl font-medium mb-10 max-w-2xl mx-auto" data-id="element-35">
            Escribinos por WhatsApp y coordinamos un turno en el horario que
            mejor te quede.
          </p>

          <WhatsAppButton variant="white" className="text-2xl py-5 px-10 shadow-lg" data-id="element-36">
            <span className="flex items-center gap-3" data-id="element-37">
              Reservar Turno por WhatsApp <span className="text-3xl" data-id="element-38">💬</span>
            </span>
          </WhatsAppButton>
        </motion.div>
      </div>
    </section>;
};